(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deep-gems-back-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deep-gems-back-to-top')) {
    customElements.define('deep-gems-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.scrollContainer = document.querySelector('.page-wrapper') || window;
        this.updateVisibility = () => { this.hidden = (this.scrollContainer === window ? window.scrollY : this.scrollContainer.scrollTop) < 500; };
        this.scrollContainer.addEventListener('scroll', this.updateVisibility, { passive: true, signal });
        window.addEventListener('pageshow', this.updateVisibility, { signal });
        this.querySelector('button').addEventListener('click', () => {
          const target = document.querySelector('#header-group a[href]') || document.querySelector('#MainContent');
          if (target) {
            if (!target.matches('a, button, [tabindex]')) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }
          this.scrollContainer.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
        this.updateVisibility();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deep-gems-player"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-deep-gems-player]:not([data-player-ready])');
    if (!roots.length) return;

    const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>';
    const pauseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zm6 0h4v14h-4z"></path></svg>';

    const normalizeTitle = (value) => String(value || '')
      .normalize('NFKD')
      .toLowerCase()
      .replace(/[’‘]/g, "'")
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');

    const parseSource = (source) => {
      try {
        const url = new URL(source);
        const parts = url.pathname.split('/').filter(Boolean);
        const country = parts[0] && parts[0].length === 2 ? parts[0] : 'gb';
        const trackId = url.searchParams.get('i');
        const pathId = [...parts].reverse().find((part) => /^\d+$/.test(part));
        return { source, country, id: trackId || pathId, isTrack: Boolean(trackId) };
      } catch {
        return null;
      }
    };

    const jsonpLookup = ({ country, id, isTrack }) => new Promise((resolve) => {
      if (!id) { resolve([]); return; }

      const callbackName = `deepGemsInline_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      const script = document.createElement('script');
      let settled = false;

      const finish = (results) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        delete window[callbackName];
        script.remove();
        resolve(results);
      };

      const timer = setTimeout(() => finish([]), 8000);

      window[callbackName] = (payload) => {
        const results = Array.isArray(payload?.results) ? payload.results : [];
        const tracks = results.filter((item) => item.wrapperType === 'track' && item.kind === 'song' && item.previewUrl);
        finish(isTrack ? tracks.slice(0, 1) : tracks);
      };

      const params = new URLSearchParams({ id, country, callback: callbackName });
      if (!isTrack) params.set('entity', 'song');
      script.src = `https://itunes.apple.com/lookup?${params.toString()}`;
      script.onerror = () => finish([]);
      document.head.appendChild(script);
    });

    roots.forEach(async (root) => {
      root.dataset.playerReady = 'true';

      const playerAccordion = root.closest('details');

      const audio = root.querySelector('[data-deep-gems-audio]');
      const tracklistNode = root.querySelector('[data-deep-gems-tracklist]');
      const sourceNode = root.querySelector('[data-deep-gems-sources]');
      const mappingNode = root.querySelector('[data-deep-gems-mapping]');
      const tracklistElement = playerAccordion?.querySelector('.product-tracklist .tracklist')
        || document.querySelector('.product-tracklist .tracklist');
      if (!audio || !tracklistElement) return;

      // Keep a legacy preview-only accordion hidden, but never hide the
      // visible tracklist when the player engine is rendered alongside it.
      if (playerAccordion && !playerAccordion.contains(tracklistElement)) {
        playerAccordion.hidden = true;
      }

      let tracklist = [];
      let productSources = [];
      let previewMapping = [];

      try {
        const parsed = JSON.parse(tracklistNode?.textContent || '[]');
        tracklist = Array.isArray(parsed) ? parsed.filter((item) => item?.type !== 'heading') : [];
      } catch { tracklist = []; }

      try {
        const parsed = JSON.parse(sourceNode?.textContent || '[]');
        productSources = Array.isArray(parsed) ? parsed : [];
      } catch { productSources = []; }

      try {
        const parsed = JSON.parse(mappingNode?.textContent || '[]');
        previewMapping = Array.isArray(parsed) ? parsed : [];
      } catch { previewMapping = []; }

      const rows = Array.from(tracklistElement.querySelectorAll(':scope > .row'));
      if (!rows.length) return;

      const rowStates = rows.map((row, index) => {
        const item = tracklist[index] || {};
        const slot = document.createElement('span');
        slot.className = 'track-preview-slot';
        slot.setAttribute('aria-hidden', 'true');
        const position = row.querySelector('.position');
        if (position) position.insertAdjacentElement('afterend', slot);
        return { index, item, row, slot, button: null, seek: null, previewUrl: null, appleTrackId: null, progress: 0 };
      });

      tracklistElement.classList.add('deep-gems-preview-enhanced');

      let active = null;
      let pendingSeekRatio = null;

      const labelFor = (item, index) => {
        const artist = item?.artist ? `${item.artist} - ` : '';
        return `${artist}${item?.title || `Preview ${index + 1}`}`;
      };

      const setProgress = (state, percent) => {
        if (!state) return;
        const clamped = Math.min(100, Math.max(0, percent));
        state.row.style.setProperty('--track-preview-progress', `${clamped}%`);
        if (state.seek) state.seek.setAttribute('aria-valuenow', String(Math.round(clamped)));
        state.progress = clamped;
      };

      const resetState = (state, resetProgress = true) => {
        if (!state) return;
        state.row.classList.remove('is-playing');
        if (state.button) {
          state.button.innerHTML = playIcon;
          state.button.setAttribute('aria-pressed', 'false');
        }
        if (resetProgress) setProgress(state, 0);
      };

      const startState = async (state, seekRatio = null) => {
        if (!state?.previewUrl) return;
        const sameTrack = active === state && audio.dataset.trackIndex === String(state.index);

        if (!sameTrack) {
          if (active) resetState(active, true);
          audio.src = state.previewUrl;
          audio.dataset.trackIndex = String(state.index);
          active = state;
          pendingSeekRatio = seekRatio;
          setProgress(state, seekRatio === null ? 0 : seekRatio * 100);
        } else if (seekRatio !== null) {
          if (Number.isFinite(audio.duration) && audio.duration > 0) {
            audio.currentTime = seekRatio * audio.duration;
            setProgress(state, seekRatio * 100);
            pendingSeekRatio = null;
          } else {
            pendingSeekRatio = seekRatio;
          }
        }

        try { await audio.play(); } catch { resetState(state, false); }
      };

      const activateState = (state, track) => {
        if (!state || !track?.previewUrl || state.previewUrl) return;
        state.previewUrl = track.previewUrl;
        state.appleTrackId = track.trackId ? String(track.trackId) : null;
        state.row.classList.add('has-preview');
        state.slot.removeAttribute('aria-hidden');

        const label = labelFor(state.item, state.index);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'track-preview-button';
        button.innerHTML = playIcon;
        button.setAttribute('aria-label', `Play ${label}`);
        button.setAttribute('aria-pressed', 'false');

        const seek = document.createElement('button');
        seek.type = 'button';
        seek.className = 'track-preview-seek';
        seek.setAttribute('role', 'slider');
        seek.setAttribute('aria-label', `Seek ${label}`);
        seek.setAttribute('aria-valuemin', '0');
        seek.setAttribute('aria-valuemax', '100');
        seek.setAttribute('aria-valuenow', '0');

        state.button = button;
        state.seek = seek;
        state.slot.appendChild(button);
        state.row.appendChild(seek);

        button.addEventListener('click', async () => {
          if (active === state && !audio.paused) { audio.pause(); return; }
          await startState(state);
        });

        seek.addEventListener('click', async (event) => {
          const rect = seek.getBoundingClientRect();
          if (!rect.width) return;
          const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
          setProgress(state, ratio * 100);
          await startState(state, ratio);
        });

        seek.addEventListener('keydown', async (event) => {
          let next = null;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = state.progress - 5;
          if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = state.progress + 5;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = 100;
          if (next === null) return;
          event.preventDefault();
          const clamped = Math.min(100, Math.max(0, next));
          setProgress(state, clamped);
          await startState(state, clamped / 100);
        });
      };

      const mapTracksByTitle = (states, appleTracks) => {
        const used = new Set();
        states.forEach((state) => {
          if (state.previewUrl) return;
          const wanted = normalizeTitle(state.item?.title);
          if (!wanted) return;
          const matchIndex = appleTracks.findIndex((track, index) => !used.has(index) && normalizeTitle(track.trackName) === wanted);
          if (matchIndex >= 0) {
            used.add(matchIndex);
            activateState(state, appleTracks[matchIndex]);
          }
        });
        return used;
      };

      const explicitSongIds = new Set();

      await Promise.all(previewMapping.map(async (entry) => {
        const trackIndex = Number(entry?.track);
        const sourceIndex = Number(entry?.source);
        if (!Number.isInteger(trackIndex) || !Number.isInteger(sourceIndex)) return;

        const state = rowStates[trackIndex];
        const source = productSources[sourceIndex];
        if (!state || !source) return;

        const sourceDetails = parseSource(source);
        if (!sourceDetails) return;

        const songId = entry?.song ? String(entry.song) : String(sourceDetails.id || '');
        if (!songId) return;

        const resolved = await jsonpLookup({ ...sourceDetails, id: songId, isTrack: true });
        const exactTrack = resolved.find((item) => String(item.trackId) === songId) || resolved[0];
        if (!exactTrack?.previewUrl) return;

        explicitSongIds.add(songId);
        activateState(state, exactTrack);
      }));

      const enrichedStates = rowStates.filter((state) => !state.previewUrl && state.item?.apple_music_url);
      await Promise.all(enrichedStates.map(async (state) => {
        const details = parseSource(state.item.apple_music_url);
        if (!details) return;
        const resolved = await jsonpLookup(details);
        if (resolved[0]?.previewUrl && !explicitSongIds.has(String(resolved[0].trackId))) activateState(state, resolved[0]);
      }));

      const unmappedStates = () => rowStates.filter((state) => !state.previewUrl);
      const sourceDetails = productSources.map(parseSource).filter(Boolean);
      const withoutExplicitSongs = (tracks) => tracks.filter((track) => !explicitSongIds.has(String(track.trackId)));

      if (unmappedStates().length && sourceDetails.length === 1 && !sourceDetails[0].isTrack) {
        const remaining = unmappedStates();
        const albumTracks = withoutExplicitSongs(await jsonpLookup(sourceDetails[0]));
        const used = mapTracksByTitle(remaining, albumTracks);

        if (albumTracks.length === remaining.length) {
          remaining.forEach((state, index) => {
            if (state.previewUrl || used.has(index)) return;
            const track = albumTracks[index];
            if (track?.previewUrl) {
              used.add(index);
              activateState(state, track);
            }
          });
        }
      } else if (unmappedStates().length && sourceDetails.length) {
        const resolvedGroups = await Promise.all(sourceDetails.map(jsonpLookup));
        const resolvedTracks = withoutExplicitSongs(resolvedGroups.flat());
        const remaining = unmappedStates();
        const used = mapTracksByTitle(remaining, resolvedTracks);

        if (resolvedTracks.length === remaining.length) {
          remaining.forEach((state, index) => {
            if (state.previewUrl || used.has(index)) return;
            const track = resolvedTracks[index];
            if (track?.previewUrl) {
              used.add(index);
              activateState(state, track);
            }
          });
        }
      }

      audio.addEventListener('loadedmetadata', () => {
        if (!active || pendingSeekRatio === null || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
        audio.currentTime = pendingSeekRatio * audio.duration;
        setProgress(active, pendingSeekRatio * 100);
        pendingSeekRatio = null;
      });

      audio.addEventListener('play', () => {
        if (!active) return;
        active.row.classList.add('is-playing');
        if (active.button) {
          active.button.innerHTML = pauseIcon;
          active.button.setAttribute('aria-pressed', 'true');
        }
      });

      audio.addEventListener('pause', () => {
        if (!active) return;
        active.row.classList.remove('is-playing');
        if (active.button) {
          active.button.innerHTML = playIcon;
          active.button.setAttribute('aria-pressed', 'false');
        }
      });

      audio.addEventListener('ended', () => {
        if (!active) return;
        resetState(active, true);
      });

      audio.addEventListener('timeupdate', () => {
        if (!active || !Number.isFinite(audio.duration) || audio.duration <= 0) return;
        setProgress(active, (audio.currentTime / audio.duration) * 100);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
